export default {
  get baseUrl(): string {
    return process.env.VUE_APP_API_BASE_URL || "";
  }
};
